/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};
$(document).ready(function () {

	$(window).on('popstate', function() {
		location.reload(true);
 	});

	 const burger = document.querySelector('.burger')
	 const navigation = document.querySelector('.header__navigation')
	 const nav_links = document.querySelectorAll('.nav-link')
	 burger.addEventListener('click', function() {
	   if(this.classList.contains('opened')){
		 burger.classList.remove('opened')
		 navigation.classList.remove('opened')
		 document.body.classList.remove('overflow')
	   } else{
		 this.classList.add('opened')
		 navigation.classList.add('opened')
		 document.body.classList.add('overflow')
	   }
	 })
   
	 nav_links.forEach((label, index) => label.addEventListener('click', () => {
	   burger.classList.remove('opened')
	   navigation.classList.remove('opened')
	   document.body.classList.remove('overflow')
	 }))

	 $('.people__view-all').click(function(){
		$('.people__cards--hidden').addClass('show');
	});
 
	$('.js-hero-down').on('click', function(e) {
		e.preventDefault();
		var nextSection = $('.values').offset();
		console.log(nextSection);
		$('html, body').animate({ scrollTop: nextSection.top }, '50');
	});

	$('.js-section-block').each(function() {
		var sectionHeight = $(window).innerHeight() - $(this).find('.section-title').innerHeight();
		$(this).find('.section-item').css({
			height: sectionHeight + 'px'
		});
	});
	
	var swiper = new Swiper('.js-section-slider', {
		effect: 'fade',
		speed: 600,
		autoplay: {
			delay: 6000,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		
	});

	var swiperPeople = new Swiper('.js-people-line', {
		slidesPerView: 3,
    spaceBetween: 10,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		scrollbar: {
			el: '.swiper-scrollbar',
			hide: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			768: {
				slidesPerView: 1,
			},
			1200: {
				slidesPerView: 2,
			},
		}
	});

	var swiper2 = new Swiper('.js-reviews-slider', {
		slidesPerView: 1,
		autoHeight: false,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		on: {
			slideChangeTransitionStart: function() {
				$(".reviews-slider__arrows").css("height", $(".js-reviews-slider .swiper-slide-active .reviews-bottom").innerHeight());
				$(".reviews-text").css({
					height: $('.js-reviews-slider .swiper-slide').innerHeight() - $(".js-reviews-slider .reviews-bottom").innerHeight() + 'px'
				});
			}
		}
	});
	$(".reviews-text").css({
		height: $('.js-reviews-slider .swiper-slide').innerHeight() - $(".js-reviews-slider .reviews-bottom").innerHeight() + 'px'
	});
	$(".reviews-slider__arrows").css("height", $(".js-reviews-slider .swiper-slide-active .reviews-bottom").innerHeight());

	$('.js-navbar-search').on('click', function(e){
		$(this).toggleClass('active');
		$('.js-navbar-field').toggleClass('show');
	});

	$('.js-people-item__link').mouseover(function(){
		$('.js-people-item__link').addClass('fogging');
		$(this).removeClass('fogging');
	 });
	 $('.js-people-item__link').mouseout(function(){
		$('.js-people-item__link').removeClass('fogging');
	 });

	$(document).mouseup(function (e){ // событие клика по веб-документу
		var form = $(".navbar-search-wrap"); // тут указываем ID элемента
		if (!form.is(e.target) // если клик был не по нашему блоку
		    && form.has(e.target).length === 0) { // и не по его дочерним элементам
			form.find('.js-navbar-search').removeClass('active');
			form.find('.js-navbar-field').removeClass('show');
			 // скрываем его
		}
	});

});

$(window).on('resize', function(){
	$('.js-section-block').each(function() {
		var sectionHeight = $(window).innerHeight() - $(this).find('.section-title').innerHeight();
		$(this).find('.section-item').css({
			height: sectionHeight + 'px'
		});
	});
	$(".reviews-text").css({
		height: $('.js-reviews-slider .swiper-slide').innerHeight() - $(".js-reviews-slider .reviews-bottom").innerHeight() + 'px'
	});
	$(".reviews-slider__arrows").css("height", $(".js-reviews-slider .swiper-slide-active .reviews-bottom").innerHeight());
});
/******/ })()
;